"use strict";

angular.module('app.models.device', []).//

factory('__Device', ['restmod', 'appConfig', '__Datapoint', '__MenuEntry', '$filter', 'f_User','f_Devices','xCenterConfig', function (restmod, appConfig, __Datapoint, __MenuEntry, $filter, f_User,f_Devices,xCenterConfig) {


    return restmod.model('/Device').mix('BaseModel').mix({
        VisualizationDatapoints: {
            hasMany: '__Datapoint'
        },
        /*
         LogSettings: {
         'hasOne': '__DeviceLogSettings'
         },*/
        // 'VisualizationDatapoints.DatapointValue._typ' : {mask:'$type'},
        $config: {name: 'ResponseData', plural: 'ResponseData'},
        $pk: 'DeviceId',
        updateDeviceData: function(data){
            if(data.Flags != undefined){
                this.Flags = data.Flags;
                this.$dispatch('resolve-flags');
                if(data.$UI != undefined) {
                    this.$UI = data.$UI;
                }
            }
            if(data.Address != undefined) {
                this.Address = data.Address;
            }


            if(data.DeviceType!= undefined)  {
                this.DeviceType = data.DeviceType;
            }
            if(data.IsOffline!= undefined) {
                this.IsOffline = data.IsOffline;
            }
            if(data.IsDisabled!= undefined) {
                this.IsDisabled = data.IsDisabled;
            }


        },
        prepareDevice: function () {
            if(!this.$UI){ this.$UI = {}; }
            this.$dispatch('resolve-flags');


        },
        $hooks: {
            'resolve-flags': function () {
                var UserLevel = f_User.getUserLevel();
                /*if(
                 b.DatapointValue.Flags == 2
                 || b.DatapointValue.Flags == 3
                 || b.DatapointValue.Flags == 4
                 || b.DatapointValue.Flags == 6
                 || b.DatapointValue.Flags == 7
                 || b.DatapointValue.Flags == 10
                 || b.DatapointValue.Flags == 11
                 || b.DatapointValue.Flags == 14
                 || b.DatapointValue.Flags == 15)
                 {
                 b.DatapointValue.Logging = true;
                 b.SomeLogging = true;
                 }*/
                var VALUEFLAG =
                {
                    "HasActivatedTimeProgram": 1,
                    "LoggingEnabled": 2,
                    "IsInSceneAction": 4,
                    //"HasFavorite": 8,
                    "StatisticEnabled": 16,
                    "IsInScene": 32
                };
                this.LoggingEnabled = this.StatisticEnabled = this.IsInSceneAction = this.LoggingEnabled = this.HasActivatedTimeProgram = this.HasFavorite = false;
                this.$UI.LoggingEnabledByUserlevel = false;
                if ((this.Flags & VALUEFLAG.StatisticEnabled )) {
                    this.$UI.StatisticEnabled = true;

                        this.$UI.LoggingEnabledByUserlevel = true;


                } else {
                    this.$UI.StatisticEnabled = false;
                }

                if ((this.Flags & VALUEFLAG.LoggingEnabled )) {
                    this.$UI.LoggingEnabled = true;
                    if (UserLevel > 10) {
                        this.$UI.LoggingEnabledByUserlevel = true;
                    }

                }

                if ((this.Flags & VALUEFLAG.IsInScene )) {
                    this.$UI.IsInScene = true;
                }

                if ((this.Flags & VALUEFLAG.HasActivatedTimeProgram )) {
                    this.$UI.HasActivatedTimeProgram = true;
                }

                if ((this.Flags & VALUEFLAG.IsInSceneAction )) {
                    this.$UI.IsInSceneAction = true;
                }

                if ((this.Flags & VALUEFLAG.HasFavorite )) {
                    this.$UI.HasFavorite = true;
                }
                // = (_ENUM.VALUEFLAG.HasActivatedTimeProgram | _ENUM.VALUEFLAG.HasActivatedTimeProgram);
            },
            'before-save': function (_req) {
                /* Transform $save Calls */
                _req.url = appConfig().api_host + 'Device/UpdateDevice';
                _req.method = 'POST';
                var o = {$type: _req.data._type};
                var u = _req.data;
                delete u._type;
                _req.data = {'Device': angular.extend(o, u)};
            },
            'after-request': function (_req) {
                if (typeof _req.data == 'string') {
                    _req.data = {'DeviceId': _req.data};
                }else{

                }
            },
            'before-destroy': function (_req) {
                _req.url = appConfig().api_host + 'Device/RemoveDevice';
                _req.method = 'POST';
                _req.data = {'DeviceId': this.DeviceId};
            },

            'build-view-datapoints': function () {
                var self = this;
                var iIndex = 0;
                // "BatteryState":  "49fa9f10-c988-4782-b970-0a3daf13df5f",
                // "SignalStrength": "a49387b7-e1b9-4270-be14-752868641a00",
                var wellKnownDatapointsByDeviceType;
                if(xCenterConfig.wellKnownDatapointsByDeviceType.hasOwnProperty( this.DeviceType )) {
                    wellKnownDatapointsByDeviceType = xCenterConfig.wellKnownDatapointsByDeviceType[self.DeviceType];
                }else{
                    wellKnownDatapointsByDeviceType = [];
                }
                //delete self.$UI.LeftSideVisualizationDatapoint;
                //delete self.$UI.RightSideVisualizationDatapoint;
                //delete self.$UI.FavoriteTopVisualizationDatapoint;
                //delete self.$UI.FavoriteBottomVisualizationDatapoint;


                var searchDP = ["49fa9f10-c988-4782-b970-0a3daf13df5f", "a49387b7-e1b9-4270-be14-752868641a00"];

                if (self.VisualizationDatapoints) {
                    // build first two dataPoints

                    // build battery and signal status
                    for (var i = 0; i < self.VisualizationDatapoints.length; ++i) {

                        var dataPoint = self.VisualizationDatapoints[i];

                        // If BatteryState Or Signal strength
                        if(!dataPoint.Config){ continue; };

                        var index = searchDP.indexOf(dataPoint.Config.DatapointConfigId);
                        if(index >= 0){
                            // Its a BatteryState Or SignalStrength
                            if (index === 0) {
                                this.$UI.BatteryStatus = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(dataPoint).$dispatch('build').$dispatch('set-color-class');
                                this.$UI.BatteryStatus.$UI.restMod = true;
                                this.$UI.BatteryStatus.$UI.HideInList = true;
                                // If Battery is first or second datapoint
                                // Left/RightSide if/else must ignore this Datapoint
                                if (i < 2) {
                                    iIndex++;
                                }
                            }
                            // Signal
                            if (index === 1) {
                                this.$UI.SignalStatus = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(dataPoint).$dispatch('build').$dispatch('set-color-class');
                                this.$UI.SignalStatus.$UI.restMod = true;
                                this.$UI.SignalStatus.$UI.HideInList = true;
                                if (i < 2) {
                                    iIndex++;
                                }
                            }

                        }else{
                            // If we have WellKnownFavoriteVisualizationDatapoints
                            if(wellKnownDatapointsByDeviceType){
                                var wellKnownDatapointByDeviceTypeIndex = wellKnownDatapointsByDeviceType.indexOf(dataPoint.Config.DatapointConfigId);
                                switch(wellKnownDatapointByDeviceTypeIndex){
                                    case 0:
                                        self.$UI.FavoriteTopVisualizationDatapoint = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(dataPoint);
                                        break;
                                    case 1:
                                        self.$UI.FavoriteBottomVisualizationDatapoint = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(dataPoint);
                                        break;

                                }
                            }

                            if(!self.$UI.LeftSideVisualizationDatapoint){
                                self.$UI.LeftSideVisualizationDatapoint = self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                                self.$UI.LeftSideVisualizationDatapoint.$UI.restMod = true;
                            }else if(!self.$UI.RightSideVisualizationDatapoint)
                            {
                                self.$UI.RightSideVisualizationDatapoint = self.VisualizationDatapoints[i]= __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                                self.$UI.RightSideVisualizationDatapoint.$UI.restMod = true;
                            }else{
                                self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]);
                            }


                        }

                    }
                    if(!self.$UI.FavoriteTopVisualizationDatapoint){
                       /* Important for favorite boxes with two datapoints, for example weather station. */
                       self.$UI.FavoriteTopVisualizationDatapoint = self.$UI.LeftSideVisualizationDatapoint;
                    }
                    if(!self.$UI.FavoriteBottomVisualizationDatapoint){
                       /* Important for favorite boxes with two datapoints, for example weather station. */
                       self.$UI.FavoriteBottomVisualizationDatapoint = self.$UI.RightSideVisualizationDatapoint;
                    }
                    if( self.$UI.FavoriteTopVisualizationDatapoint) self.$UI.FavoriteTopVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');
                    if( self.$UI.FavoriteBottomVisualizationDatapoint) self.$UI.FavoriteBottomVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');
                    if( self.$UI.RightSideVisualizationDatapoint) self.$UI.RightSideVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');
                    if( self.$UI.LeftSideVisualizationDatapoint) self.$UI.LeftSideVisualizationDatapoint.$dispatch('build').$dispatch('set-color-class');

                }


            },
            'build-additional-datapoints': function () {
                var self = this;
                var searchDP = ["49fa9f10-c988-4782-b970-0a3daf13df5f", "a49387b7-e1b9-4270-be14-752868641a00"];

                if (!self.VisualizationDatapoints || self.$UI.buildAllDatapoints == true) {
                    return
                }
                ;
                for (var i = 0; i < self.VisualizationDatapoints.length; ++i) {
                    //console.log('-'+self.VisualizationDatapoints[i].DatapointValue.$type);

                    var index = searchDP.indexOf(self.VisualizationDatapoints[i].Config.DatapointConfigId);
                    if (index >= 0) {
                        // We have a SignalStrengh Or Battery Datapoint
                        // Battery
                        if (index === 0) {
                            this.$UI.BatteryStatus = self.VisualizationDatapoints[i];

                            this.$UI.BatteryStatus.$UI.HideInList = true;

                        }
                        // Signal
                        if (index === 1) {
                            this.$UI.SignalStatus = self.VisualizationDatapoints[i];

                            this.$UI.SignalStatus.$UI.HideInList = true;

                        }
                    }
                    if (!self.VisualizationDatapoints[i].$UI || !self.VisualizationDatapoints[i].$UI.restMod) {
                        self.VisualizationDatapoints[i] = __Datapoint.$buildRaw(self.VisualizationDatapoints[i]).$dispatch('build');
                        self.VisualizationDatapoints[i].$UI.restMod = true;
                    }

                }
                self.$UI.buildAllDatapoints = true;


            }

            ,
            'after-feed': function (data) {
                if (this.$UI == undefined) {
                    this.$UI = {};
                }
                this.prepareDevice();
                f_Devices.addOrUpdateDevice(this);
                // Extract BatteryStatus
                // Extract Connection Datapoint
                //console.log(data);

            }

        },
        $extend: {
            Model: {
                /*$byId: function (_params, withDetails) {
                 return this.$collection().$decorate({
                 'before-request': function (_req) {
                 _req.method = 'POST';
                 _req.url = appConfig().api_host + 'Device/GetDevice';
                 _req.data = {'DeviceId': _params};
                 if (withDetails) {
                 _req.data.withDetails = true;
                 }
                 ;
                 _req.params = null;
                 }, 'after-request': function (_req) {
                 _req.data = [_req.data];
                 }
                 }, function () {
                 console.log('param', this);
                 return this.$fetch();
                 });
                 },*/
            }
            ,
            Scope: {
                $byId: function (deviceId, withDetails) {
                    return this.$collection().$decorate({
                        'before-request': function (_req) {
                            _req.method = 'POST';
                            _req.data = {'DeviceId': deviceId};
                            if (withDetails) {
                                _req.data.WithDetails = withDetails;
                            }

                            _req.params = null;
                            _req.url = appConfig().api_host + 'Device/GetDevice';
                        }

                    }, function () {
                        return this.$find().$then(function(data){
                            f_Devices.addOrUpdateDevice( data);

                        });
                    });

                }
                ,
                $getAll: function (params) {
                    return this.$collection(params).$orderBy(['+DeviceType', '+Name']).$decorate(
                        {
                            'before-request': function (_req) {
                                console.debug('Requesting devices angular-restmod...');
                                _req.method = 'GET';
                                _req.params = null;
                                _req.url = appConfig().api_host + 'Device/GetAllDevices';
                            }

                        }, function () {
                            return this.$fetch().$then(function(data){
                                if (data && Array.isArray(data)) {
                                    for(var i = 0; i < data.length; i++)
                                    {
                                        f_Devices.addOrUpdateDevice(data[i]);
                                    }
                                }

                            });;
                        });
                }
                ,
                $getDevicesByMenuEntry: function (params) {
                    return this.$collection(params).$orderBy(['+DeviceType', '+Name']).$decorate(
                        {
                            'before-request': function (_req) {
                                _req.method = 'POST';
                                _req.params = null;
                                _req.url = appConfig().api_host + 'Device/GetDevicesByMenuEntry';
                                _req.data = params;
                            },
                            'after-feed-many':function(data)
                            {
                                if (data && Array.isArray(data)) {
                                    for(var i = 0; i < data.length; i++)
                                    {
                                        f_Devices.addOrUpdateDevice(data[i]);
                                    }
                                }
                            }
                        }, function () {
                            return this.$fetch();
                        });
                }
                ,
                $getNew: function (params) {
                    return this.$collection(params).$orderBy(['+DeviceType', '+Name']).$decorate(
                        {
                            'before-request': function (_req) {
                                _req.method = 'POST';
                                _req.params = null;
                                _req.url = appConfig().api_host + 'Device/GetLearnModeState';
                                _req.data = {Protocol: -1, LearnModeOptions: params};
                            },
                            'after-request': function (_req) {
                                this.learnModeStates = _req.data.LearnModeStates;
                                this.updatedDevices = _req.data.UpdatedDevices;
                                _req.data = _req.data.NewDevices;

                            }
                        }, function () {
                            return this.$fetch();
                        });
                }
                ,
                $getChildEntries: function (params) {
                    return this.$collection().$orderBy(['+DeviceType', '+Name']).$decorate(
                        {
                            'before-request': function (_req) {
                                _req.method = 'POST';
                                _req.params = null;
                                _req.data = angular.extend({DeviceId: this.DeviceId}, params);
                                _req.url = appConfig().api_host + 'Menu/GetChildEntries';

                            },
                            'after-feed':function(data)
                            {
                                if (data && data.Devices && Array.isArray(data.Devices)) {
                                    for(var i = 0; i < data.Devices.length; i++)
                                    {
                                        f_Devices.addOrUpdateDevice(data.Devices[i]);
                                    }
                                }
                            }
                        }, function () {
                            return this.$fetch();
                        });
                },
                $getByFilter: function (filter) {
                    /* Filter:
                     List deviceTypes,
                     List menuEntries,
                     bool withDetails,
                     bool withChildDevices
                     bool recursive
                     */
                    return this.$collection(filter).$orderBy(['+DeviceType', '+Name']).$decorate({
                        'before-request': function (_req) {
                            _req.method = 'POST';
                            _req.data = filter;
                            _req.params = null;

                            _req.url = appConfig().api_host + 'Device/GetDevicesByFilter';
                        },
                        'after-feed-many':function(data)
                        {
                            if (data && Array.isArray(data)) {
                                for(var i = 0; i < data.length; i++)
                                {
                                    f_Devices.addOrUpdateDevice(data[i]);
                                }
                            }
                        }
                    }, function () {
                        return this.$fetch();
                    });
                }
                ,


            }
            ,
            List: {
                // If using restmod < 1.1.5 the use Collection instead.
                $orderBy: function (_what) {
                    var ordered = $filter('orderBy')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                $filter: function (_what) {
                    var ordered = $filter('filter')(this, _what);
                    // reset the collection contents:
                    this.length = 0;
                    this.push.apply(this, ordered);
                    return this;
                },
                filterByDeviceType: function (_dt) {
                    return this.$asList(function (_devices) {
                        return _devices.filter(_device => {
                            let b;

                            if (typeof _dt == 'object' && _dt.length > 0) {
                                b = _dt.indexOf(_device.DeviceType) >= 0;
                            } else {
                                b = _dt == _device.DeviceType;
                            }
                            return b;
                        });
                    });
                },
                addIfNotExist: function (newDevice) {
                    var isNew = true;

                    for (var i = 0; i < this.length; ++i) {
                        if (this[i].DeviceId === newDevice.DeviceId) {
                            isNew = false;
                        }
                    }


                    if (isNew && newDevice != undefined) {
                        this.push(angular.copy(newDevice));
                        //return this.$fetch();
                    }
                },
                getAllChildrenOf: function (device) {
                    return $filter('filter')(this, function (e) {
                        return (e.ParentDeviceId == device.DeviceId);
                    });
                }
            },
            Record: {
                $add: function () {
                    var self = this;
                    return self.$send({
                        url: appConfig().api_host + 'Device/AddDevice',
                        method: 'POST',
                        isArray: false,
                        data: {'Device': self.$encode()}
                    });
                }
                ,
                $getRoom: function () {
                    var self = this;
                    return __MenuEntry.$byId(self.ParentMenuEntryId, '00000000-0000-0000-0000-000000000000', false).$asPromise();
                }

            }
        }
    })


}])./* Data Model */
factory('_Device', [function () {
    'ngInject';

    return {};


}]);
